/**
 * /admin/subscriptions - retired. The customer ledger merged into /admin/users.
 *
 * Kept as a redirect so bookmarks and shared links keep working. The filter
 * params use the same names on both pages (q, audience, status, pending,
 * plans), so they carry over as-is; the pre-audience `comp=true` bookmark form
 * maps to `audience=granted`, the chip closest to the old filter.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';
import { parseUsersSearch, type UsersSearch } from '@/lib/admin/user-filters';

/** The users contract plus the legacy `comp=true` -> `audience=comp` mapping. */
function validateSubscriptionsSearch(search: Record<string, unknown>): UsersSearch {
  const out = parseUsersSearch(search);
  if (!out.audience && (search.comp === true || search.comp === 'true')) {
    // "granted" is the word every admin surface uses now; `comp` is its legacy
    // spelling and the same set on the server.
    out.audience = 'granted';
  }
  return out;
}

export const Route = createFileRoute('/admin/subscriptions')({
  validateSearch: validateSubscriptionsSearch,
  beforeLoad: ({ search }) => {
    // The router is not in strict search mode, so the `search` a match carries
    // is the raw URL search merged under the validated one - an unknown legacy
    // `comp` survives validateSearch and would be copied into the new URL.
    // Re-running the contract yields only the known keys, so the destination
    // carries nothing the /admin/users page does not own.
    throw redirect({ to: '/admin/users', search: validateSubscriptionsSearch(search), replace: true });
  },
});
